"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { ContactsRoutedPage } from './deskUi/ContactsRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function ContactsSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={ContactsRoutedPage} Loading={MsgDeskLoading} />
}
